// extracted by mini-css-extract-plugin
export var alignCenter = "_9b-d";
export var bannerShown = "_9b-6";
export var buttonContent = "_9b-0";
export var cardList = "_9b-1";
export var centerContent = "_9b-2";
export var chevron = "_9b-3";
export var closePanelButton = "_9b-k";
export var conversationContextContainer = "_9b-l";
export var conversationDetailContainer = "_9b-4";
export var detailWrapper = "_9b-7";
export var dropdownButton = "_9b-e";
export var dropdownTitle = "_9b-9";
export var fullHeight = "_9b-5";
export var hidden = "_9b-a";
export var icon = "_9b-b";
export var mergeSuggestionWrapper = "_9b-m";
export var panel = "_9b-i";
export var portalButtonsWrapper = "_9b-c";
export var right = "_9b-j";
export var tableSummaryContainer = "_9b-8";
export var tableSummaryHeader = "_9b-g";
export var threeDotsButton = "_9b-f";
export var wide = "_9b-h";